import { render, staticRenderFns } from "./Crearcirugia.vue?vue&type=template&id=1a617117"
import script from "./Crearcirugia.vue?vue&type=script&lang=js"
export * from "./Crearcirugia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports